var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ribbon)?_c('dynamic-link',{staticClass:"ribbon-link",attrs:{"to":_vm.ribbon.linkUrl,"target":_vm.isLaunch ? '_self' : '_blank',"event":{ location: 'top ribbon', content: _vm.ribbon.labelPrimary }}},[_c('s-ribbon',_vm._b({},'s-ribbon',_vm.ribbon,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }